<div>
  <div class="header-style">
    <div class="total-number">
      <p><span i18n="@@totalManufacturers">Total Number Of Manufacturers: </span>{{totalSize}}</p>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)" i18n-aria-label="@@paginator"></mat-paginator>
      
      @if (manufacturersList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item i18n="@@exportCsv" (click)="exportManufacturers(1)">Export as CSV</button>
          <button mat-menu-item i18n="@@exportPdf" (click)="exportManufacturers(2)">Export as PDF</button>
          <button mat-menu-item i18n="@@exportExcel" (click)="exportManufacturers(3)">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" i18n-aria-label="@@export" [matMenuTriggerFor]="exportMenu"></mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="manufacturers_search_input" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="manufacturers_clear_button" class="cursor" matSuffix i18n-aria-label="@@clearSearch" (click)="clearSearch()">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="manufacturers_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-aria-label="@@searchIcon"></mat-icon>
    </div>
  </div>
  @for (item of manufacturersList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'details-box mr-16 ' : 'details-box')}}">
      <mat-card-content class="d-flex">
        <img class="cursor" (click)="goToManufacturer(item.businessName, item.id)" [src]="item.picturePath" (error)="onImgError($event)" i18n-alt="@@manufacturerImageAlt" alt="Manufacturer image"/>
        <div class="content-box">
          <div class="w-90 cursor" (click)="goToManufacturer(item.businessName, item.id)">
            @if (item.firstName) {
              <div class="mat-subtitle-1 margin-bottom">
                {{item.firstName + ' ' + item.lastName}} @if (utils.getUserStatus(item.status) === 'banned') {<span i18n="@@baned">(Baned)</span>}
              </div>
            }
            @if (!item.firstName) {
              <div class="mat-subtitle-1 margin-bottom">
                {{item.businessName}} <span i18n="@@owner"> Owner</span> @if (utils.getUserStatus(item.status) === 'banned') {<span i18n="@@baned"> (Baned)</span>}
              </div>
            }
            <div class="mat-caption margin-bottom" matTooltip ellipsisTooltip>{{item.businessName}}</div>
            <div class="mat-caption margin-bottom" matTooltip ellipsisTooltip>{{item.phone ? '+' : ''}}{{item.countryCode}}{{item.phone}}</div>
            <div class="mat-caption margin-bottom" matTooltip ellipsisTooltip>{{item.registrationDate}}</div>
            <div class="mat-caption" matTooltip ellipsisTooltip i18n="@@planLabel">Plan: {{ utils.planNameByCount(item.promotionCodeCount,"manufacturer")}}</div>
          </div>
          <div class="d-flex">
            <mat-icon class="cursor vertical-icon" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label="@@moreOptions">more_vert</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            @if (utils.getUserStatus(item.status) === 'banned') {
              <button i18n="@@unban" data-testid="unban_button" (click)="unblock(item.id)" mat-menu-item>Unban</button>
            }
            @if (utils.getUserStatus(item.status) === 'active') {
              <button i18n="@@ban" data-testid="ban_button" (click)="block(item.id)" mat-menu-item>Ban</button>
            }
          </mat-menu>
        </div>
      </mat-card-content>
    </mat-card>
  }
  @if (manufacturersList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@emptyViewAlt" alt="Empty view"/>
  }
</div>
